<div class="modal-dialog m-0" style="max-width: 100%">
  <div class="modal-content" style="border: none">
    <app-modal-header-common [title]="'Risk Update'" [dialogRef]="dialogRef">
    </app-modal-header-common>
    <div class="form-scrollable-area" style="height: 70vh; max-height: 70vh">
      <div class="px-3 py-3">
        <ul>
          <li *ngFor="
              let breadcrumb of breadCrumbData;
              first as isFirst;
              last as isLast
            ">
            <span *ngIf="!isLast" class="color-history-inactive">{{
              breadcrumb
              }}</span>
            <span *ngIf="isLast" class="color-active">{{ breadcrumb }}</span>
          </li>
        </ul>
      </div>

      <div class="modal-body p-0">
        <div class="row" style="padding-left: 29px; font-size: 14px">
          {{ riskMetric.domain }} | {{ riskMetric.subdomain }} |
          <ng-container *ngIf="res?.risk_custom_id">{{res.risk_custom_id}} - </ng-container>{{ riskMetric.risk }}
        </div>
        <div class="saw">
          <div class="d-flex mb-2" style="align-items: center">
            <span class="sjec gol">Risk Type: </span>
            <span>{{ res.risk_type?.display_name }}
            </span>
          </div>
          <div class="d-flex mb-2" style="align-items: center">
            <span class="sjec gol">Risk Response: </span>

            <mat-select class="fw-500" [(ngModel)]="riskMetric.risk_response" (ngModelChange)="handleRes()"
              class="msel">
              <mat-option value="Accept">Accept</mat-option>
              <mat-option value="Mitigate">Mitigate</mat-option>
            </mat-select>
          </div>
        </div>
        <div class="risk-score-row">
          <div class="risk-field">
            <label>Risk Impact</label>
            <mat-form-field appearance="outline">
              <mat-select [value]="selectedRiskImpact?.id" (selectionChange)="onImpactChange($event.value)">
                <mat-option *ngFor="let item of riskImpactList" [value]="item.id">
                  {{ item.display_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Risk Likelihood -->
          <div class="risk-field">
            <label>Risk Likelihood</label>
            <mat-form-field appearance="outline">
              <mat-select [value]="selectedRiskLikelihood?.id" (selectionChange)="onLikelihoodChange($event.value)">
                <mat-option *ngFor="let item of riskLikelihoodList" [value]="item.id">
                  {{ item.display_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Inherent Risk Score -->
          <div class="risk-field">
            <label>Inherent Risk Score</label>
            <div class="score-box" [ngStyle]="{ 'background-color': getRiskScoreColor(), color: 'white' }">
              {{ inherentRiskScore || '0' }}
            </div>
          </div>
        </div>
        <mat-tab-group>
          <mat-tab label="Risk Response">
            <form [formGroup]="riskMetricAcceptCreateForm" *ngIf="riskMetric.risk_response == 'Accept'"
              class="accept-form">
              <!-- Closed Date -->
              <div class="form-row">
                <div class="form-label">Closed Date</div>

                <mat-form-field class="w-25" appearance="outline">
                  <input matInput [matDatepicker]="picker" readonly formControlName="due_date"
                    (click)="picker.open()" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>

              <!-- Comments -->
              <div class="form-row">
                <div class="form-label">Comments</div>

                <mat-form-field class="w-50" appearance="outline">
                  <textarea matInput formControlName="comments" cdkTextareaAutosize cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="6"></textarea>
                </mat-form-field>
              </div>

              <!-- Upload Files -->
              <div class="form-row">
                <div class="form-label">Upload Files</div>

                <div class="upload-box p-3 rounded border" style="
                    background-color: #f9f9f9;
                    position: relative;
                    max-width: 50%;
                  ">
                  <input #fileUpload type="file" (change)="onFileSelected($event)" multiple hidden />

                  <button mat-stroked-button color="primary" (click)="fileUpload.click()" type="button">
                    <mat-icon class="me-2">cloud_upload</mat-icon>
                    Upload File
                  </button>

                  <div class="d-flex gap-3 mt-3" style="overflow-x: auto; white-space: nowrap">
                    <!-- New files -->
                    <div *ngFor="let file of uploadFiles; let i = index"
                      class="d-flex justify-content-between p-2 border rounded bg-white" style="width: 200px">
                      <mat-icon>insert_drive_file</mat-icon>

                      <span class="filename-ellipsis" [matTooltip]="file.name">
                        {{ file.name }}
                      </span>

                      <button mat-icon-button color="warn" (click)="removeFile(i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>

                    <!-- Existing files -->
                    <div *ngFor="let file of uploadedFiles; let i = index"
                      class="d-flex justify-content-between p-2 border rounded bg-white" style="width: 200px">
                      <div class="d-flex align-items-center w-50">
                        <mat-icon class="me-1">insert_drive_file</mat-icon>
                        <span class="filename-ellipsis" [matTooltip]="file.file_name">
                          {{ file.file_name }}
                        </span>
                      </div>

                      <button mat-icon-button matTooltip="Download" (click)="downloadRiskFile(file.id)">
                        <mat-icon>cloud_download</mat-icon>
                      </button>

                      <button mat-icon-button color="warn" matTooltip="Remove" (click)="removeUploadedFile(file.id, i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="riskMetric.risk_response === 'Accept' && showResidualSection" class="risk-score-row"
                style="margin-top:10px; max-width:850px;">
                <!-- Residual Risk Impact -->
                <div class="risk-field">
                  <label>Residual Risk Impact</label>
                  <mat-form-field appearance="outline">
                    <mat-select [value]="selectedResidualImpact?.id"
                      (selectionChange)="onResidualImpactChange($event.value)" disabled>
                      <mat-option *ngFor="let item of riskImpactList" [value]="item.id">
                        {{ item.display_name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Residual Risk Likelihood -->
                <div class="risk-field">
                  <label>Residual Risk Likelihood</label>
                  <mat-form-field appearance="outline">
                    <mat-select [value]="selectedResidualLikelihood?.id"
                      (selectionChange)="onResidualLikelihoodChange($event.value)" disabled>
                      <mat-option *ngFor="let item of riskLikelihoodList" [value]="item.id">
                        {{ item.display_name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Residual Risk Score -->
                <div class="risk-field">
                  <label>Residual Risk Score</label>
                  <div class="score-box"
                    [ngStyle]="{ 'background-color': getResidualRiskScoreColor(), color: 'white' }">
                    {{ residualRiskScore ?? '0' }}
                  </div>
                </div>
              </div>
              <!-- Checkbox -->
              <div *ngIf="projectOwner" class="checkbox-row">
                <mat-checkbox class="risk-warning-checkbox" [checked]="isClosed()"
                  (change)="toggleStatus($event.checked)">
                  <span class="checkbox-text" [ngClass]="{ 'checkbox-error': showCheckboxError }">
                    This risk is backed by adequate preventive & detective
                    controls - accepting it does not pose material exposure to
                    the business.
                  </span>
                </mat-checkbox>
              </div>
            </form>

            <form [formGroup]="riskMetricCreateForm" *ngIf="riskMetric.risk_response == 'Mitigate'" class="accept-form">
              <div class="row" style="margin-top:8px;">
                <!-- Preventive Controls -->
                <div class="col-md-6">
                  <h6 class="mb-2">Preventive Controls</h6>

                  <div class="table-container table-responsive control-table">
                    <table class="table table-bordered">
                      <thead style="position: sticky; z-index: 1; top: 0; background: white">
                        <tr>
                          <th class="text-center">#</th>
                          <th class="w-100 text-center">Control</th>
                          <th class="text-center" style="width: 150px;">Type</th>
                          <th class="text-center">Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr *ngFor="let ctrl of preventiveControls.controls; let i = index; let isLast = last"
                          [formGroup]="ctrl">
                          <td class="text-center">{{ i + 1 }}</td>

                          <td class="pt-2">
                            <mat-form-field appearance="outline" style="width: 100%">
                              <mat-label>Control</mat-label>
                              <textarea matInput formControlName="description" maxlength="150"
                                [matAutocomplete]="preventiveAuto" (input)="onControlInput(ctrl)" cdkTextareaAutosize
                                cdkAutosizeMinRows="1" cdkAutosizeMaxRows="6">
                              </textarea>
                              <mat-autocomplete #preventiveAuto="matAutocomplete" [displayWith]="displayControl"
                                (optionSelected)="onControlSelected($event.option.value, ctrl)">
                                <mat-option *ngFor="let opt of getFilteredControls('preventive')" [value]="opt">
                                  {{ opt.description }}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
                          </td>

                          <td class="pt-2">
                            <mat-form-field appearance="outline" style="width: 150px">
                              <mat-label>Type</mat-label>
                              <mat-select formControlName="type">
                                <mat-option *ngFor="let type of riskControlTypes" [value]="type.id">
                                  {{ type.display_name }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>

                          <td class="text-center">
                            <button *ngIf="isLast" mat-icon-button color="primary" (click)="addPreventiveControl()">
                              <mat-icon>add</mat-icon>
                            </button>

                            <button mat-icon-button color="warn" (click)="removePreventiveControl(i)">
                              <img src="./assets/images/delete.svg" height="18" />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Detective Controls -->
                <div class="col-md-6">
                  <h6 class="mb-2">Detective Controls</h6>

                  <div class="table-container table-responsive control-table">
                    <table class="table table-bordered">
                      <thead style="position: sticky; z-index: 1; top: 0; background: white">
                        <tr>
                          <th class="text-center">#</th>
                          <th class="w-100 text-center">Control</th>
                          <th class="text-center" style="width: 150px;">Type</th>
                          <th class="text-center">Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr *ngFor="let ctrl of detectiveControls.controls; let i = index; let isLast = last"
                          [formGroup]="ctrl">
                          <td class="text-center">{{ i + 1 }}</td>

                          <td>
                            <mat-form-field appearance="outline" style="width: 100%">
                              <mat-label>Control</mat-label>
                              <textarea matInput formControlName="description" maxlength="150"
                                [matAutocomplete]="detectiveAuto" (input)="onControlInput(ctrl)" cdkTextareaAutosize
                                cdkAutosizeMinRows="1" cdkAutosizeMaxRows="6">
                              </textarea>
                              <mat-autocomplete #detectiveAuto="matAutocomplete" [displayWith]="displayControl"
                                (optionSelected)="onControlSelected($event.option.value, ctrl)">
                                <mat-option *ngFor="let opt of getFilteredControls('detective')" [value]="opt">
                                  {{ opt.description }}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
                          </td>

                          <td class="pt-2">
                            <mat-form-field appearance="outline" style="width: 150px">
                              <mat-label>Type</mat-label>
                              <mat-select formControlName="type">
                                <mat-option *ngFor="let type of riskControlTypes" [value]="type.id">
                                  {{ type.display_name }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>

                          <td class="text-center">
                            <button *ngIf="isLast" mat-icon-button color="primary" (click)="addDetectiveControl()">
                              <mat-icon>add</mat-icon>
                            </button>

                            <button mat-icon-button color="warn" (click)="removeDetectiveControl(i)">
                              <img src="./assets/images/delete.svg" height="18" />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="task-toolbar">
                <h6>Mitigation Tasks</h6>
                <div class="toolbar-actions">
                  <button type="button" mat-button mat-stroked-button (click)="openHistory()" class="me-2"
                    style="height: 36px;">
                    <mat-icon>history</mat-icon>
                    History
                  </button>
                  <button type="button" mat-button mat-flat-button color="primary" (click)="addMetricItems()"
                    [disabled]="isReadOnlyStatus() || projectOwner" style="height: 36px;">
                    <mat-icon>add</mat-icon>
                    Mitigation Task
                  </button>
                </div>
              </div>
              <app-loading *ngIf="!isLoaded"></app-loading>
              <mat-accordion *ngIf="isLoaded">
                <mat-expansion-panel #panelElement *ngFor="let m of riskMetricCreateForm.controls; let i = index"
                   [formGroup]="m">
                  <mat-expansion-panel-header>
                    <div class="panel-header">
                      <!-- LEFT SIDE SUMMARY -->
                      <div class="panel-summary">
                        <span class="task-index"> {{ i + 1 }}. </span>

                        <span class="task-name" [matTooltip]="m.value.mitigation_task">
                          {{ m.value.mitigation_task || "Mitigation Task" }}
                        </span>
                      </div>
                      <span class="summary-item">
                        {{ getFunctionName(m.value.function) || "Function" }}
                      </span>

                      <span class="summary-item">
                        {{
                        delegatedUserNameMap?.[m.value.delegated_to] ||
                        "Delegated"
                        }}
                      </span>

                      <span class="summary-item">
                        {{ m.value.due_date | appFormat: "date" }}
                      </span>

                      <span class="summary-item status">
                        {{ m.value.status || "Open" }}
                      </span>
                      <!-- DELETE BUTTON RIGHT -->
                      <button mat-icon-button color="warn" (click)="removeMetric(i); $event.stopPropagation()"
                        *ngIf="!isReadOnlyStatus() && !projectOwner">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </mat-expansion-panel-header>

                  <!-- PANEL CONTENT -->
                  <div class="p-2">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Mitigation Task</mat-label>
                      <textarea matInput formControlName="mitigation_task" [readonly]="isReadOnlyStatus() || projectOwner"
                        cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="6"></textarea>
                    </mat-form-field>

                    <div class="grid-row">
                      <mat-form-field appearance="outline">
                        <mat-label>Type</mat-label>
                        <mat-select formControlName="type" [disabled]="isReadOnlyStatus() || projectOwner">
                          <mat-option *ngFor="let type of riskControlTypes" [value]="type.id">
                            {{ type.display_name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                        <mat-label>Function</mat-label>
                        <mat-select formControlName="function" (selectionChange)="onFunctionChange($event.value, i)"
                          [disabled]="isReadOnlyStatus() || projectOwner">
                          <mat-option *ngFor="let func of mitigationFunctions" [value]="func.id">
                            {{ func.display_name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field appearance="outline">
                        <mat-label>Function Owner</mat-label>
                        <input matInput [value]="functionOwners?.[i]" readonly />
                      </mat-form-field>

                      <mat-form-field appearance="outline">
                        <mat-label>Risk Owner</mat-label>
                        <mat-select formControlName="delegated_to" [disabled]="isReadOnlyStatus() || projectOwner">
                          <mat-option *ngFor="let user of delegatedUsersList[i]" [value]="user.email">
                            {{ user.first_name }} {{ user.last_name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field appearance="outline">
                        <mat-label>Due Date</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="due_date" readonly
                          (click)="!isReadOnlyStatus() && !projectOwner && picker.open()" />
                        <mat-datepicker-toggle matSuffix [for]="picker"
                          [disabled]="isReadOnlyStatus() || projectOwner"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                        <mat-label>Status</mat-label>
                        <mat-select formControlName="status" [disabled]="isReadOnlyStatus() || projectOwner">
                          <mat-option value="Open">Open</mat-option>
                          <mat-option value="Closed">Closed</mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field appearance="outline">
                        <mat-label>Risk Owner Comments</mat-label>
                        <textarea matInput [value]="actionCommentsMap[i] || ''" readonly cdkTextareaAutosize
                          cdkAutosizeMinRows="1" cdkAutosizeMaxRows="6"></textarea>
                      </mat-form-field>




                    </div>

                    <!-- Attachments -->
                    <p>Uploaded Files</p>

                    <div class="attachment-section">
                      <!-- No files state -->
                      <div *ngIf="!actionFileList[i] || actionFileList[i].length === 0" class="text-muted"
                        style="padding: 4px;">
                        -
                      </div>
                      <div *ngFor="let file of actionFileList[i] || []" class="attachment-item">
                        <mat-icon>insert_drive_file</mat-icon>

                        <span [matTooltip]="file.file_name" class="filename-ellipsis">{{ file.file_name }}</span>

                        <button mat-icon-button (click)="downloadFile(file.id, file.file_name)">
                          <mat-icon>cloud_download</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>

              <!-- Approval Comments and Action Buttons -->
              <div class="form-row" style="margin-top: 12px; display: flex; align-items: center; gap: 10px;">
                <div class="form-label" style="width: auto; margin:0px;"> CRO Comments</div>
                <mat-form-field class="w-50" appearance="outline" style="margin-bottom: -1.25em;">
                  <textarea matInput [(ngModel)]="approvalComments" [ngModelOptions]="{ standalone: true }"
                    placeholder="Enter comments..."
                    [disabled]="!projectOwner || res?.status?.display_name !== 'Under Review'" cdkTextareaAutosize
                    cdkAutosizeMinRows="1" cdkAutosizeMaxRows="6"></textarea>
                </mat-form-field>
                <ng-container *ngIf="projectOwner && res?.status?.display_name === 'Under Review'">
                  <mat-checkbox [checked]="selectedApprovalAction === 'Accepted'" [disabled]="!approvalComments?.trim()"
                    (change)="$event.checked ? onApprove() : onUncheck()" class="me-3 approve-checkbox" color="primary">
                    Approve
                  </mat-checkbox>

                  <mat-checkbox [checked]="selectedApprovalAction === 'Rejected'" [disabled]="!approvalComments?.trim()"
                    (change)="$event.checked ? onReject() : onUncheck()" class="reject-checkbox" color="warn">
                    Reject
                  </mat-checkbox>
                </ng-container>
              </div>



              <!-- Mitigate Checkbox -->
              <div class="checkbox-row" style="margin-top: 12px;" *ngIf="projectOwner">
                <mat-checkbox class="risk-warning-checkbox" [(ngModel)]="mitigateCheckboxChecked"
                  [ngModelOptions]="{ standalone: true }" [disabled]="isReadOnlyStatus() || selectedApprovalAction !== 'Accepted'"
                  (change)="showMitigateCheckboxError = false">
                  <span class="checkbox-text" [ngClass]="{ 'checkbox-error': showMitigateCheckboxError }">
                    This risk is backed by adequate preventive &amp; detective
                    controls - accepting it does not pose material exposure to
                    the business.
                  </span>
                </mat-checkbox>
              </div>
            </form>

            <div *ngIf=" riskMetric.risk_response === 'Mitigate' && hasActions" class="risk-score-row"
              style="margin-top:10px; max-width:850px;">
              <!-- Residual Risk Impact -->
              <div class="risk-field">
                <label>Residual Risk Impact</label>
                <mat-form-field appearance="outline">
                  <mat-select [value]="selectedResidualImpact?.id"
                    (selectionChange)="onResidualImpactChange($event.value)">
                    <mat-option *ngFor="let item of riskImpactList" [value]="item.id">
                      {{ item.display_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Residual Risk Likelihood -->
              <div class="risk-field">
                <label>Residual Risk Likelihood</label>
                <mat-form-field appearance="outline">
                  <mat-select [value]="selectedResidualLikelihood?.id"
                    (selectionChange)="onResidualLikelihoodChange($event.value)">
                    <mat-option *ngFor="let item of riskLikelihoodList" [value]="item.id">
                      {{ item.display_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Residual Risk Score -->
              <div class="risk-field">
                <label>Residual Risk Score</label>
                <div class="score-box" [ngStyle]="{ 'background-color': getResidualRiskScoreColor(), color: 'white' }">
                  {{ residualRiskScore ?? '0' }}
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Scoring Matrix">
            <div class="p-4 scoring-matrix">
              <div class="table-responsive overflow-auto pr-2">
                <table class="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th class="diagonal">
                        <span>Likelihood</span>
                        <span>Impact</span>
                      </th>
                      <th *ngFor="let impact of riskImpactList" style="background-color: #b0b0ae; color: #111">
                        {{ impact.display_name }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let likelihood of riskLikelihoodList; let i = index">
                      <td class="fw-bold">
                        {{ likelihood.display_name }}
                      </td>
                      <td *ngFor="let impact of riskImpactList" [ngStyle]="{
                            'background-color': getScoreColor(getRiskScore(impact.name, likelihood.name)),
                            'color': 'white'
                          }" [ngClass]="{
                            'selected-cell': isSelectedCell(impact.id, likelihood.id)
                          }">
                        {{ getRiskScore(impact.name, likelihood.name) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="risk-legend mt-3">
                <div class="legend-title">
                  Likelihood × Impact = Risk Score
                </div>
                <div class="legend-row">
                  <div class="legend-range">{{ getRiskRanges().low }}</div>
                  <div class="legend-box low">Low</div>
                </div>
                <div class="legend-row middle">
                  <div class="legend-range">{{ getRiskRanges().medium }}</div>
                  <div class="legend-box medium">Medium</div>
                </div>
                <div class="legend-row">
                  <div class="legend-range">{{ getRiskRanges().high }}</div>
                  <div class="legend-box high">High</div>
                </div>
              </div>

              <div class="mt-3">
                <b>Note:</b>
                <div>
                  <b>Inherent risk</b> refers to the level of risk that exists in the absence of any controls or
                  mitigations.
                </div>
                <div>
                  <b>Residual risk</b> is the level of risk that remains after controls, measures, or mitigations have
                  been applied.
                </div>
              </div>
            </div>


          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
    <div class="dialog-footer">
      <button mat-button color="secondary" (click)="closeDialog()">
        Close
      </button>

      <div *appHasAccess="{ roles: ['!vendor'] }">
        <button mat-raised-button color="primary" (click)="saveMetric()" *ngIf="riskMetric.risk_response"
          [disabled]="riskMetric.risk_response === 'Accept' && !projectOwner">
          Save
        </button>
      </div>
    </div>
  </div>
</div>


<ng-template #historyDialogTemplate>
  <div class="modal-dialog m-0" style="max-width: 100%">
    <div class="modal-content" style="border: none">
      <app-modal-header-common [title]="'Risk Comment History'" [dialogRef]="historyDialogRef">
      </app-modal-header-common>
      <div class="form-scrollable-area" style="min-height: 400px; padding: 16px;">
        <app-action-history [actionId]="res?.id" historyType="risk"></app-action-history>
      </div>
    </div>
  </div>
</ng-template>